<template>
<div class="row item-view">

	<div class="col-12">
		<partial-loader :loading="isFetching"></partial-loader>
	</div>

	<div class="col-12"
	     v-show="!isFetching">

		<b-table :class="{'is-loading': isFetching}"
				v-if="pendingBids"
				 
				striped
				hover
				show-empty
				:items="pendingBids.data"
				:fields="pendingBidsFields"
				:per-page="parseInt(pendingBids.per_page)"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:busy="isFetching">

			<template v-slot:cell(created_at)="row">
				{{ row.item.created_at | smallDate }}
			</template>

			<template v-slot:cell(price)="row">
				<span v-if="row.item.price">&euro; {{ Math.round(row.item.price) }}</span>
			</template>

			<template v-slot:cell(buyer)="row">
				{{ row.item.buyer.full_name_simple }}
			</template>
			
		</b-table>

		<p v-else>
			{{ $t('pendingBid.noData') }}
		</p>

		<b-pagination v-model="currentPage"
		              :total-rows="pendingBids.total"
		              :per-page="parseInt(pendingBids.per_page)"
		              align="right"></b-pagination>
	</div>
</div>
</template>

<script>
import { isNil } from 'lodash';
import PartialLoader from '@/components/elements/PartialLoader';
import { smallDate } from '@/filters/date-filters.js';
import PendingBidService from '@/services/pending-bid-service';
import { isCancel, CancelToken } from 'axios';

export default {
	components: {
		PartialLoader
	},
	filters: {
		smallDate
	},
	data() {
		return {
			isFetching: true,
			pendingBids: [],
			pendingBidsFields: [
				{ key: 'created_at', label: this.$t('common.date') },
				{ key: 'pending_bid_number', label: this.$t('pendingBid.number') },
				{ key: 'price', label: this.$t('common.price') },
				{ key: 'buyer', label: this.$t('item.category') }
			],
			currentPage: 1,
			perPage: 10,
			sortBy: 'id',
			sortDesc: true,
			filter: null,
			errors: false
		}
	},
	watch: {
		'currentPage': 'fetchPendingBids'
	},
	methods: {
		fetchPendingBids() {
			this.isFetching = true;

			if (!isNil(this.cancelToken)) {
				this.cancelToken.cancel();
			}

			this.cancelToken = CancelToken.source();

			const params = {
				page: this.currentPage,
				sort: this.sortBy,
				order: this.sortDesc ? 'desc' : 'asc',
				total: this.perPage
			}

			return PendingBidService.getItemPendingBids(this.$route.params.itemId, params, this.cancelToken.token).then(response => {
				this.isFetching = false;
				this.pendingBids = response;
			}).catch(error => {
				if (!isCancel(error)) {
					this.isFetching = false;
					this.error = error.message;
				}
			});
		},
		init() {
			this.fetchPendingBids(this.$route.params.itemId);
		}
	},
	mounted() {
		this.init();
	}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// PendingBidListSmall.vue?64b3b3a2